/* eslint-disable no-param-reassign */
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '../../../../state/hooks';

import { Assessment } from '../../../../state/reduxRepositories/assessments/assessments.interfaces';

interface AssessmentFormState {
  module: any;
}

interface TrialProps {
  wordsPresented?: string[];
  wordsRecalled?: string[];
  noAnswersCorrect?: boolean;
}

interface ModuleDetailPayload {
  moduleName: string;
  key: string;
  value: string | number | boolean | string[] | TrialProps | Date;
}

const initialState: AssessmentFormState = {
  module: {} as any,
};

export const assessmentCreationViewSlice = createSlice({
  name: 'assessmentCreationViewSlice',
  initialState,
  reducers: {
    updateAssessmentModule: (
      state,
      action: PayloadAction<Assessment | null>,
    ) => {
      state.module = { ...state.module, ...action.payload };
    },

    updateAssessmentModuleDetails: (
      state: any,
      action: PayloadAction<ModuleDetailPayload>,
    ) => {
      const { moduleName, key, value } = action.payload;
      state.module = {
        ...state.module,
        [moduleName]: { ...state.module[moduleName], [key]: value },
      };
    },

    resetAssessmentModuleDetailsForSkip: (
      state: any,
      action: PayloadAction<ModuleDetailPayload>,
    ) => {
      const { moduleName } = action.payload;
      state.module = {
        ...state.module,
        [moduleName]: { skipModuleFlag: true },
      };
    },

    resetAssessment: (state: any): void => {
      state.module = {};
    },
  },
});

export const assessmentModuleSelector = (state: RootState): any | null =>
  state.assessmentCreationReducer.module;

export const {
  updateAssessmentModuleDetails,
  updateAssessmentModule,
  resetAssessmentModuleDetailsForSkip,
  resetAssessment,
} = assessmentCreationViewSlice.actions;
